import { useState } from "react";
import type { CSSProperties } from "react";
import { useMutation } from "@tanstack/react-query";
import { apiPost } from "@vimaana/ui";

const KATS = [{ v: "bug", l: "Fehler" }, { v: "wunsch", l: "Wunsch / Idee" }, { v: "frage", l: "Frage" }];

export default function FeedbackPage() {
  const [kategorie, setKategorie] = useState("wunsch");
  const [beschreibung, setBeschreibung] = useState("");
  const m = useMutation({
    mutationFn: () => apiPost<{ id: string }>("/api/kontor/feedback", { kategorie, beschreibung, page_path: "/feedback", environment: "prod" }),
  });
  const send = () => { if (beschreibung.trim()) m.mutate(); };
  return (
    <div style={wrap}>
      <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800 }}>Feedback</h1>
      <div style={{ color: "var(--vg-text-3)", marginTop: 4, fontSize: 13, marginBottom: 22 }}>Wünsche &amp; Fehler melden — landet direkt bei Ben.</div>
      {m.isSuccess ? (
        <div style={{ ...card, textAlign: "center" }}>
          <div style={{ fontSize: 40, color: "var(--vg-green)" }}>✓</div>
          <div style={{ fontWeight: 700, marginTop: 6 }}>Danke! Dein Feedback ist angekommen.</div>
          <button style={{ ...btnGhost, marginTop: 14 }} onClick={() => { m.reset(); setBeschreibung(""); }}>Noch eins senden</button>
        </div>
      ) : (
        <div style={card}>
          <label style={fieldL}>Art
            <select value={kategorie} onChange={(e) => setKategorie(e.target.value)} style={input}>
              {KATS.map((k) => <option key={k.v} value={k.v}>{k.l}</option>)}
            </select>
          </label>
          <label style={{ ...fieldL, marginTop: 14 }}>Beschreibung
            <textarea value={beschreibung} onChange={(e) => setBeschreibung(e.target.value)} rows={5} placeholder="Was ist dir aufgefallen?" style={{ ...input, resize: "vertical" }} />
          </label>
          {m.isError && <div style={{ color: "var(--vg-red)", fontSize: 13, marginTop: 8 }}>Konnte nicht gesendet werden.</div>}
          <button onClick={send} disabled={!beschreibung.trim() || m.isPending} style={{ ...btnPrimary, marginTop: 14, opacity: (!beschreibung.trim() || m.isPending) ? 0.5 : 1 }}>{m.isPending ? "Sendet…" : "Absenden"}</button>
        </div>
      )}
    </div>
  );
}

const wrap: CSSProperties = { maxWidth: 680, margin: "0 auto", padding: "22px 22px 60px" };
const card: CSSProperties = { background: "var(--vg-bg-2)", border: "1px solid var(--vg-line)", borderRadius: 12, padding: "18px 20px" };
const fieldL: CSSProperties = { display: "flex", flexDirection: "column", gap: 5, fontSize: 12, fontWeight: 600, color: "var(--vg-text-3)" };
const input: CSSProperties = { padding: "9px 11px", borderRadius: 8, border: "1px solid var(--vg-line-2)", background: "var(--vg-bg-2)", color: "var(--vg-text)", fontSize: 14, fontWeight: 400 };
const btnGhost: CSSProperties = { padding: "8px 14px", borderRadius: 9, border: "1px solid var(--vg-line-2)", background: "var(--vg-bg-2)", color: "var(--vg-text-2)", fontSize: 14, cursor: "pointer" };
const btnPrimary: CSSProperties = { padding: "9px 16px", borderRadius: 9, border: "none", background: "var(--vg-accent)", color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer" };
